import React from 'react';
import { ReviewModel } from '../../../typings/reviews';
import { FiveStarsCarousel } from '../../../components/five-stars-carousel';
import ModelCard from '../model-card';
import { useTrackingManager } from '../../../services/use-tracking-manager';
import {
  onHandleCarouselLoaded,
  onHandleCollapseTextEventTracking,
  onSlideActionTracking,
} from '../../../utils/tracking-helpers';

interface ReviewsCarouselProps {
  reviewModel: ReviewModel;
}
const ReviewsCarousel = (props: ReviewsCarouselProps): JSX.Element => {
  const { reviewModel } = props;

  if (!reviewModel) return <></>;
  const reviews = reviewModel.reviews;
  const carouselReviews = reviews.slice(0, 10);
  const trackingManager = useTrackingManager();
  const onHandleCarouselAction = (
    action: 'click' | 'swipe',
    direction: string,
  ) => {
    onSlideActionTracking(action, direction, trackingManager, reviewModel);
    onHandleCarouselLoaded(trackingManager, reviewModel);
  };

  const onHandleCollapseTextAction = (state: boolean) => {
    onHandleCollapseTextEventTracking(
      state ? 'view more' : 'view less',
      trackingManager,
      reviewModel,
    );
  };

  return (
    <>
      <FiveStarsCarousel
        reviews={carouselReviews}
        onHandleCarouselAction={onHandleCarouselAction}
        onHandleCollapseTextAction={onHandleCollapseTextAction}
      >
        <ModelCard
          model={reviewModel.modelConfiguration}
          review={reviewModel}
        />
      </FiveStarsCarousel>
    </>
  );
};

export default ReviewsCarousel;
